/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { financialsRetentionSegmentDtoSchema } from "./financialsRetentionSegmentDtoSchema.ts";
import { z } from "zod/v4";

export const financialsRetentionMetricDtoSchema = z.object({
  title: z.optional(z.string()),
  get segments() {
    return z.array(financialsRetentionSegmentDtoSchema).optional();
  },
});
